<template>
  <div class="container" v-if="repartidor != null">
    <div class="row">
      <div class="col-4">
        <div class="profile-img">
          <img :src="avatar_url" alt="" />
          <div class="file btn btn-lg btn-primary">
            Cambiar Foto
            <input type="file" name="file" />
          </div>
        </div>
        <p class="badge badge-secondary" style="display:block;padding:5px">
          Perfil: {{ repartidor.tipo }}
        </p>
      </div>
      <div class="col">
        <div class="profile-head">
          <h5>
            {{ repartidor.nombre }}
          </h5>
          <h6>
            Correo:
            <a :href="`mailto:${repartidor.perfil.email}`">
              {{ repartidor.perfil.email }}
            </a>
          </h6>
          <p class="proile-rating">
            Telefono : <span>{{ repartidor.perfil.telefono }}</span>
          </p>
          <p class="proile-rating">
            Registrado :
            <span>{{ repartidor.perfil.created_at | dateTime }}</span>
          </p>
          <p class="proile-rating">
            Estado :
            <b-badge variant="info" v-if="repartidor.activo">
              Activa
            </b-badge>
            <b-badge variant="danger" v-else>
              Suspendida
            </b-badge>
          </p>
        </div>
      </div>
      <div class="col-2">
        <!-- <input type="submit" value="Editar" /> -->
        <a @click="$router.go(-1)" class="btn-regresar">
          <i class="fas fa-arrow-circle-left"></i>
          Regresar
        </a>
      </div>
    </div>
    <!-- end row -->
    <h4 class="header text-center">
      Pedidos asignados
    </h4>
    <div class="row">
      <div class="col">
        <h5 class="header text-center">
          Por entregar
          <i>(reparto)</i>
        </h5>
        <div class="list-group">
          <a
            :href="'/pedidos/ver/' + p.pedido.id"
            class="list-group-item list-group-item-action"
            v-for="(p, i) in repartidor.pedidos.reparto"
            :key="'p-reparto-' + i"
          >
            <span class="badge badge-danger badge-pill">
              {{ p.pedido.id | pedido_id2folio }}
            </span>
            <small>
              <b>
                <i class="fas fa-calendar"></i>
                Asignado:
              </b>
              {{ p.pedido.fecha_produccion | dateTime }}
            </small>
            <small class="precio">
              {{ p.pedido.total | moneda }}
            </small>
          </a>
        </div>
        <!-- list-group -->
      </div>
      <div class="col">
        <h5 class="header text-center">
          Entregados
          <i>(cobro)</i>
        </h5>
        <div class="list-group">
          <a
            :href="'/pedidos/ver/' + p.pedido.id"
            class="list-group-item list-group-item-action"
            v-for="(p, i) in repartidor.pedidos.cobro"
            :key="'p-reparto-' + i"
          >
            <span class="badge badge-danger badge-pill">
              {{ p.pedido.id | pedido_id2folio }}
            </span>
            <small>
              <b>
                <i class="fas fa-calendar"></i>
                Entregado:
              </b>
              {{ p.pedido.fecha_reparto | dateTime }}
            </small>
            <small class="precio">
              {{ p.pedido.total | moneda }}
            </small>
          </a>
        </div>
        <!-- list-group -->
      </div>
    </div>
    <!-- end row -->
  </div>
  <div class="container" v-else>
    <h1 class="text-center">
      <b-spinner label="Loading..."></b-spinner>
      Cargando Datos
    </h1>
  </div>
</template>

<style lang="scss" scoped>
.list-group-item .badge-danger {
  margin-right: 2rem;
}
small.precio {
  font-weight: bold;
  float: right;
  color: #946b6b;
}
.emp-profile {
  padding: 3%;
  margin-top: 3%;
  margin-bottom: 3%;
  border-radius: 0.5rem;
  background: #fff;
}
.profile-img {
  text-align: center;
  img {
    width: 70%;
    height: 100%;
  }
  .file {
    position: relative;
    overflow: hidden;
    margin-top: -20%;
    width: 70%;
    border: none;
    border-radius: 0;
    font-size: 15px;
    background: #212529b8;
    cursor: pointer;
    &:hover {
      background: #5f0b07b8;
    }
    input {
      position: absolute;
      opacity: 0;
      right: 0;
      top: 0;
    }
  }
}

.profile-head h5 {
  color: #333;
}
.profile-head h6 {
  color: #0062cc;
}

.btn-regresar {
  border: none;
  border-radius: 1.5rem;
  font-weight: 600;
  color: #6c757d;
  background: #ddd;
  padding: 3px 5px;
}

.proile-rating {
  font-size: 12px;
  color: #818182;
  margin-top: 5%;
}
.proile-rating span {
  font-size: 15px;
  font-weight: 600;
}
.proile-rating span:not([class]) {
  color: #495057;
}
.profile-head .nav-tabs {
  margin-bottom: 5%;
}
.profile-head .nav-tabs .nav-link {
  font-weight: 600;
  border: none;
}
.profile-head .nav-tabs .nav-link.active {
  border: none;
  border-bottom: 2px solid #0062cc;
}
.profile-work {
  padding: 14%;
  margin-top: -15%;
}
.profile-work p {
  font-size: 12px;
  color: #818182;
  font-weight: 600;
  margin-top: 10%;
}
.profile-work a {
  text-decoration: none;
  color: #495057;
  font-weight: 600;
  font-size: 14px;
}
.profile-work ul {
  list-style: none;
}
.profile-tab label {
  font-weight: 600;
}
.profile-tab p {
  font-weight: 600;
  color: #0062cc;
}
</style>

<script>
import UserApi from "../../apis/User";
// import md5 from "js-md5";
const md5 = require("js-md5");

export default {
  data() {
    return {
      repartidor: null
    };
  },
  created() {
    UserApi.repartidor_ver(this.$route.params.id).then(d => {
      this.repartidor = d.data;
    });
  },
  components: {},
  methods: {
    /* select_pin: function(event) {
      //
    } */
  }, // end methods
  computed: {
    avatar_url: function() {
      let hash = md5.create();
      let email = this.repartidor.perfil.email.trim();
      hash.update(email);
      let h = hash.hex();
      return `https://www.gravatar.com/avatar/${h}?s=200`;
    }
  }
};
</script>
